/** Upstream Ovie Health errors (8) + analytics errors (3) + Knowledge Base errors (4) = 15 total + settings errors (5) = 20 total. */
export enum OvieHealthErrorCode {
  // Upstream Ovie Health API errors
  OvieHealthUnauthorized = 'ovie_unauthorized',
  OvieHealthForbidden = 'ovie_forbidden',
  OvieHealthNotFound = 'ovie_not_found',
  OvieHealthInvalidQuery = 'ovie_invalid_query',
  OvieHealthRateLimited = 'ovie_rate_limited',
  OvieHealth5xx = 'ovie_5xx',
  OvieHealthTimeout = 'ovie_timeout',
  OvieHealthNetwork = 'ovie_network',
  // Analytics errors
  AnalyticsNotConfigured = 'analytics_not_configured',
  AnalyticsPracticeAccessDenied = 'analytics_practice_access_denied',
  AnalyticsInvalidRange = 'analytics_invalid_range',
  // Knowledge Base errors
  KnowledgeBaseNotConfigured = 'kb_not_configured',
  KnowledgeBasePracticeAccessDenied = 'kb_practice_access_denied',
  KnowledgeBaseConflict = 'kb_conflict',
  KnowledgeBaseNotFound = 'kb_not_found',
  // Settings errors
  PreconditionRequired = 'precondition_required',
  PreconditionFailed = 'precondition_failed',
  SettingsConcurrent = 'settings_concurrent',
  WrongPmsType = 'wrong_pms_type',
  SettingsPracticeAccessDenied = 'settings_practice_access_denied',
}

/**
 * Structured error envelope returned to the browser via the dispatcher response.
 * The runtime `OvieApiError` class owns `stack` and `cause`.
 */
export interface IOvieHealthError {
  code: OvieHealthErrorCode;
  message: string;
  upstreamStatus?: number;
  retryAfterMs?: number;
}
